import { Painter } from './pixel';
import { C } from './palette';
import type { DecorKind } from '@/world/types';

/** New art at half-world-pixel precision, aligned to the existing wall attachment points. */
export function ornament(kind: DecorKind, variant: number): HTMLCanvasElement | null {
  const wide=kind==='paintingBig'||kind==='windowBig',w=wide?32:16;
  if(kind==='painting'||kind==='paintingBig'){
    const p=new Painter(w,16);
    p.panel(1,1,w-2,14,C.brassDk,C.outline,C.brass,C.woodLine);
    p.box(2,2,w-4,12,C.woodPale).box(2.5,2.5,w-5,11,C.brassDk);
    p.rect(3,3,w-6,10,C.night);
    for(const x of [1.5,w-2.5])for(const y of [1.5,13])p.rect(x,y,1,1,C.brass).rect(x,y,0.5,0.5,C.sheetSh);
    if(variant%2===0){
      // A moonlit house, sky, distant trees, and a reflected path.
      p.rect(3,9,w-6,4,'#293d43').rect(4,8,w-8,1,'#324e50');
      p.rect(w-7,4,1.5,1.5,C.moon).rect(w-6,4,0.5,0.5,C.night);
      const cx=w/2;
      p.rect(cx-3,7,6,4,'#555466').rect(cx-2,6,4,1,'#555466').rect(cx-1,5,2,1,'#555466');
      p.rect(cx-2,8,1,1,C.woodPale).rect(cx+1,8,1,1,C.woodPale).rect(cx-0.5,9.5,1,1.5,C.night);
      p.rect(cx,11,0.5,1,'#69818a').rect(cx+0.5,12,1,0.5,'#69818a');
      if(wide)for(const x of [5,9,24,27])p.rect(x,7,0.5,5,'#17272f').rect(x-1,8,2.5,1,'#20353b');
    }else{
      // A recognisable oil portrait instead of the old solid face square.
      const x=w/2;
      p.rect(x-4,10,8,3,'#3e3448').rect(x-2.5,9,5,2,'#655368');
      p.rect(x-2,5,4,5,C.skinShade).rect(x-1.5,5,3,4,C.skin).rect(x-2.5,4,5,2,'#40303b');
      p.rect(x-2.5,5,0.5,3,'#40303b').rect(x+2,5,0.5,4,'#40303b');
      p.rect(x-1.5,7,0.5,0.5,C.eye).rect(x+1,7,0.5,0.5,C.eye).rect(x,8,0.5,0.5,C.skinShade);
      p.rect(x-0.5,9,1,0.5,'#a26e72').rect(x-1,10,2,1,C.sheetSh);
    }
    return p.done();
  }
  if(kind==='window'||kind==='windowBig'){
    const p=new Painter(w,16);
    p.panel(1,0,w-2,15,C.panelDk,C.outline,C.woodPaleDk,C.panelDk);
    p.rect(3,2,w-6,11,C.night);
    p.rect(w-7,3,2,2,C.moon).rect(w-5.5,3,0.5,1,C.night);
    for(let x=4;x<w-3;x+=4)p.rect(x,10-(x%3),1,3+(x%3),'#29344b');
    for(let x=3;x<w-3;x+=wide?8:5){
      p.rect(x,2,0.5,11,C.metalDk).rect(x+0.5,2,0.5,11,C.glass);
    }
    p.rect(3,7,w-6,1,C.panelDk).rect(3,7,w-6,0.5,C.woodPaleDk);
    p.rect(0,14,w,2,C.panelDk).rect(0,14,w,0.5,C.woodPale);
    // Deep curtain folds remain separate from the reflective windowpanes.
    for(const x of [0,w-3]){
      p.rect(x,0,3,12,C.carpetRedDk).rect(x+0.5,0,0.5,10,C.carpetRedLt).rect(x+2,0,0.5,12,C.carpetRed);
      p.rect(x,10,3,0.5,C.brass).rect(x+0.5,12,2,0.5,C.carpetRedLt);
    }
    return p.done();
  }
  if(kind==='sconce'){
    const p=new Painter(16,16);
    p.panel(6,5,4,8,C.brassDk,C.outline,C.brass);
    p.rect(7,8,1,6,C.brass).rect(5,11,6,1,C.brass).rect(6,10,4,0.5,C.sheetSh);
    p.rect(7,5,2,5,C.sheetSh).rect(7,5,0.5,5,C.pillow).rect(8.5,6,0.5,1,C.pillow);
    p.rect(7.5,2,1,3,C.fire).rect(7.5,3,0.5,2,C.fireHi).rect(8,1,0.5,1,C.fireDk);
    return p.done();
  }
  return null;
}
